import React from 'react'
import { Form, Select } from 'antd'
import { PartnerKeyType } from 'interfaces/IIntegration'
import { Partner } from '../types'

type PartnerFieldProps = {
  partnerList: Partner[] | null
  /** When set, restrict the options to just this partner (e.g. characteristic → SHELTER_BUDDY only). */
  only?: PartnerKeyType
}

/** Partner picker bound to `partner_key`. */
export const PartnerField = ({ partnerList, only }: PartnerFieldProps) => {
  const list = only ? (partnerList?.filter(v => v.key === only) ?? []) : partnerList
  const partnerOptions = list?.map(partner => ({
    label: partner.name || partner.key,
    value: partner.key,
  }))

  return (
    <Form.Item
      label="Partner"
      name="partner_key"
      rules={[{ required: true, message: 'Missing a partner' }]}
    >
      <Select placeholder="Select a partner" options={partnerOptions} />
    </Form.Item>
  )
}
